import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { CouponWithUserAndRate } from "libs/dto/src/coupon";
import { queryClient } from "@/client/libs/query-client";

const getCoupon = async (id: string) => {
  const response = await axios.patch<CouponWithUserAndRate>(`/coupons/${id}`);
  return response.data;
};

export const useCoupon = (id: string) => {
  const {
    data: coupon,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["coupons", id],
    queryFn: () => getCoupon(id),
    enabled: !!id,
  });

  return { coupon, loading, error };
};
